import React, { useMemo, useState } from 'react';

// Config sources (priority): props > env > window > ''
const resolveConfig = (propsFormId, propsApiKey) => {
  const formId =
    propsFormId ||
    (typeof process !== 'undefined' && process.env && process.env.REACT_APP_CONVERTKIT_FORM_ID) ||
    (typeof window !== 'undefined' && window.CONVERTKIT_FORM_ID) ||
    '5193525';
  const apiKey =
    propsApiKey ||
    (typeof process !== 'undefined' && process.env && process.env.REACT_APP_CONVERTKIT_API_KEY) ||
    (typeof window !== 'undefined' && window.CONVERTKIT_API_KEY) ||
    'LkyCWE9ERGS0ErhzOyO54Q';
  return { formId: String(formId || '').trim(), apiKey: String(apiKey || '').trim() };
};

const isValidEmailFormat = (value) => {
  const email = String(value || '').trim();
  if (!email) return false;
  const pattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
  return pattern.test(email);
};

const SubscribeForm = ({ ctaText = 'Join OpenToWorkRemote updates', buttonText = 'Subscribe', formId: propsFormId, apiKey: propsApiKey }) => {
  const { formId, apiKey } = useMemo(() => resolveConfig(propsFormId, propsApiKey), [propsFormId, propsApiKey]);
  const isConfigured = Boolean(formId && apiKey);

  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');
  const [showValidation, setShowValidation] = useState(false);

  const invalidEmail = email && !isValidEmailFormat(email);
  const showInlineFeedback = showValidation && (!email || invalidEmail);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess(false);

    if (!isConfigured) {
      setError('Subscription unavailable. Missing config.');
      return;
    }
    if (!email) { setShowValidation(true); return; }
    if (!isValidEmailFormat(email)) { setShowValidation(true); return; }

    setIsSubmitting(true);
    try {
      const endpoint = `https://api.convertkit.com/v3/forms/${encodeURIComponent(formId)}/subscribe`;
      const res = await fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ api_key: apiKey, email, fields: { source: 'otwr-footer-subscribe' } }),
      });
      if (!res.ok) {
        const txt = await res.text();
        throw new Error(txt || String(res.status));
      }
      setSuccess(true);
      setEmail('');
    } catch (err) {
      setError('Could not subscribe right now. Please try again later.');
      // eslint-disable-next-line no-console
      console.error('ConvertKit subscribe error:', err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="subscribe-widget text-center my-3">
      <style>
        {`
          @media (min-width: 768px) {
            .otwr-subscribe-input { width: 280px; }
          }
        `}
      </style>
      <div className="mb-2 text-white" style={{ fontWeight: 600 }}>{ctaText}</div>
      {success && (
        <div className="alert alert-success py-1" role="alert" style={{ maxWidth: 520, margin: '0 auto' }}>
          Thanks! Check your inbox to confirm.
        </div>
      )}
      {!success && (
        <form onSubmit={onSubmit} className="d-flex flex-column align-items-center" noValidate>
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-center" style={{ width: '100%', maxWidth: 520, margin: '0 auto' }}>
            <input
              type="email"
              className={`form-control rounded-pill otwr-subscribe-input ${showInlineFeedback ? 'is-invalid' : ''}`}
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              aria-invalid={showInlineFeedback ? 'true' : 'false'}
              required
              style={{ flex: '0 0 auto' }}
            />
            <button
              type="submit"
              className="site-button rounded-pill mt-2 mt-md-0 ml-md-2"
              disabled={!isConfigured || isSubmitting}
              style={{ minWidth: 120 }}
            >
              {isSubmitting ? 'Submitting…' : buttonText}
            </button>
          </div>
          {showInlineFeedback && (
            <div className="invalid-feedback d-block mt-1" style={{ fontSize: 12 }}>
              {!email ? 'Please enter your email.' : 'Please enter a valid email address.'}
            </div>
          )}
          <small className="mt-2" style={{ color: 'rgba(255,255,255,0.7)' }}>No spam. Unsubscribe anytime.</small>
        </form>
      )}
      {error && !success && (
        <div className="text-danger mt-2" style={{ fontSize: 14 }}>{error}</div>
      )}
    </div>
  );
};

export default SubscribeForm;


